import {useHistory, useParams} from 'react-router-dom';
import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {Button, useToast} from "@chakra-ui/react";
import {ChevronDown, Rows2} from "lucide-react";
import {capitalize} from "lodash";
import PostList from '../../components/post_list';
import {WhiteMain} from '../../components/main';
import {FadedTopBar} from '../../components/top_bar';
import CommunityHeader from "../../components/community_header";
import {useFeedPosts} from '../../api/feed';
import {useActions, useBottomBar, useFab, useTrendingToggles} from "../../app_context";
import useFeedback from '../../utils/use_feedback';
import {useBaseCommunity, useFeedState, useLoggedIn, useStoreProfile} from '../../store';
import {useQuery} from '../../utils/router';
import {isPseudoCommunity} from "../../store/communities";
import useModal from "../../modals";
import {useCommunities} from "../../api/communities";
import {useSaveSettings} from "../../api/user";
import HomeCommunitySuggestions from "../../components/home_community_suggestions";
import {themecolors} from "../../utils/themecolors";
import TrendingToggles from "../../components/trending_toggles";
import Sheet from "../../components/bottom-sheet/sheet";
import PostSortSheet from "../../components/bottom-sheet/post_sort";
import ProfilePictureSheet from "../../components/bottom-sheet/profile_picture_sheet";
import storage from "../../utils/storage";
import NavLink from "../../components/nav_link";

const Options = styled.div`
  width: 100%;
  display: flex;
  font-weight: 600;
  align-items: center;
  color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
`;
const View = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 6px 16px;
`;
const Sort = styled.div`
  height: 36px; 
  display: flex;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  padding: 0 8px 0 16px;
  
  svg:last-of-type {
    margin-right: 4px;
    margin-left: 6px;
  }`;
const Connector = styled.div``;
const Toggles = styled.div`
  display: flex;
  margin-left: auto;
`;
const Bar = styled.div``;
const NoPosts = styled.div``;
const InFeedItems = {
    "home": {
        1: HomeCommunitySuggestions,
    },
    "all": {
/*        1: TrendingSuggestions,*/
    },
    "*": {
    },
};

const ListingPage =  styled(({className, sortBy, customFeed}) => {
    const {expand, subscribed, blocked_communities, profile_picture, moderates} = useStoreProfile();
    const history = useHistory();
    const loggedIn = useLoggedIn();
    const feedback = useFeedback();
    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity, feedId, feedName} = useParams();
    const community = (customFeed && 'win') || paramsCommunity || (!loggedIn && baseCommunity === 'home' ? 'trending' : baseCommunity);
    const communityInfo = useCommunities(feedback.channel, [paramsCommunity || baseCommunity])[0] || false;
    const isPseudoFeed = isPseudoCommunity(community);
    const {sort} = useQuery();
    const signalRef = useRef(null);

    const isTrending = (community === "all" || community === "win" || community === "trending") && !feedId;
    const trendingType = isTrending ? (community === "trending" ? "Trending" : "All") : false;
    const trendingTopics = isTrending ? (trendingType === "All" ? [] : ["Politics"]) : [];

    const feedKey = `c/${community}:${sortBy}:${sort}${(feedId && (community === 'win' || community === 'all')) ? `:${feedId}` : ''}${(!feedId && (community === 'win' || community === 'all' || community === 'trending')) ? `:isTrendingTopics:${trendingTopics}:${blocked_communities}` : ''}`;

    const feedState = useFeedState(feedKey);
    const [restoredState, setRestoredState] = useState(feedState?.updatedTime > Date.now() - (15 * 60 * 1000) ? feedState : false);

    const {posts, loading, refresh, loadNextPage, polled} = useFeedPosts(feedback.channel, feedKey, isTrending ? "all" : community, sortBy, sort, feedId, signalRef, trendingTopics, !restoredState);
    const topics = false;
    useBottomBar();
    useFab(community);
    useTrendingToggles(isPseudoCommunity(community) && community !== 'home' && !feedId);
    const modal = useModal();

    const [sortOpen, setSortOpen] = useState(false);
    const handleSort = async () => {
        setSortOpen(true);
    }

    const [noticeOpen, setNoticeOpen] = useState(false);

    useEffect(() => {
        const dismissedNoticeProfilePicture = localStorage.getItem('dismissedNoticeProfilePicture');
        if (!dismissedNoticeProfilePicture && loggedIn && profile_picture?.length === 0) {
            setNoticeOpen(true);
        }
    }, [loggedIn, profile_picture]);

    const handleNotice = async (state) => {
        setNoticeOpen(false);
        storage.setItem("dismissedNoticeProfilePicture", Date.now());
        if (state) {
            history.push('/settings/profile')
        }
    }

    const saveSettings = useSaveSettings();
    const actions = useActions();
    const toast = useToast();
    const handleView = async () => {
        const changes = {
            expand: expand === "card" ? "condensed" : "card",
        };
        toast({
            title: `Toggled Post View.`,
            status: 'success',
            isClosable: true,
        });
        actions.settingsChanged(changes);
        try {
            await saveSettings(changes);
        } catch {
            // fail silently
        }
    };

    const [offset, setOffset] = useState(0);
    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {
        //window.history.scrollRestoration = 'manual';
    }, []);

    const emptyHome = loggedIn && community.toLowerCase() === "home" && subscribed.length === 0;

    return (
        <>
            {(isPseudoFeed || !isPseudoFeed) && (
                <>
                    <FadedTopBar active={offset > 44} search community={community} sidebar={isPseudoFeed || baseCommunity.toLowerCase() === community.toLowerCase()} settings
                            style={{position: 'fixed'}} feedTitle={!isPseudoFeed && (communityInfo.display_name || community)} back={!isPseudoFeed && baseCommunity.toLowerCase() !== community.toLowerCase()}
                    modTools={!isPseudoFeed && moderates.includes(communityInfo.name)}/>
                    <div style={{paddingTop: 50}}>
                        {(community === "all" || community === "home" || community === "trending") &&
                            <TrendingToggles />
                        }
                    </div>
                </>
            )}
            {!isPseudoFeed && (
                <>
                    <CommunityHeader community={communityInfo} onClick={refresh} pageType={`${capitalize(sortBy)} Posts`}
                                     sort={sortBy} refresh={refresh} feedKey={feedKey} feedId={feedId} feedName={feedName}/>
                </>
            )}

            <WhiteMain className={className}>
                {isPseudoFeed &&
                    <Options>
                        <Sort onClick={handleSort}>
                            {`Sort by ${capitalize(sortBy)} Posts`}
                            <ChevronDown size={16} />
                        </Sort>
                        {isPseudoFeed && <Connector/>}
                        <Toggles>
                            <View onClick={handleView}>
                                <Rows2 style={{marginRight: '4px'}} size={16} />
                                <ChevronDown size={16} />
                            </View>
                        </Toggles>
                    </Options>
                }
                {emptyHome &&
                    <NoPosts>
                        <p>No posts yet.</p>
                        <NavLink href={"/c/trending"}>
                            <Button variant={"blue"} style={{fontWeight: 600, margin: '0 auto', textAlign: 'center', borderRadius: 48}}>Go to Trending</Button>
                        </NavLink>
                    </NoPosts>
                }
                {!emptyHome &&
                    <PostList
                        isTrending={isTrending}
                        hideBlocked
                        expand={expand}
                        community={paramsCommunity}
                        posts={posts}
                        refresh={refresh}
                        loadNextPage={loadNextPage}
                        feedKey={feedKey}
                        topics={topics}
                        loading={loading}
                        sort={sortBy}
                        signalRef={signalRef}
                        polled={polled}
                        inFeed={!feedId && (InFeedItems[community] || InFeedItems["*"])}
                        showAds
                        isCommunityFeed={!isPseudoFeed}
                        restoredState={restoredState}
                        inMainFeed
                    />
                }
            </WhiteMain>
            {sortOpen && <Sheet onClose={() => setSortOpen(false) } padding={"menu"}><PostSortSheet onClose={() => setSortOpen(false) } sort={sortBy} refresh={refresh} feedKey={feedKey} feedId={feedId} feedName={feedName} community={community} /></Sheet>}
            {noticeOpen && <Sheet onClose={() => handleNotice(false) } padding={"header"}><ProfilePictureSheet onContinue={() => handleNotice(true) } onClose={() => handleNotice(false) } /></Sheet>}
        </>
    );
})`
  ${Connector} {
    flex-grow: 1;
    height: 1px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_6 : themecolors.light_border};
  }
  ${Bar} {
    margin-top: 6px;
    flex-grow: 1;
    height: 1px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_6 : themecolors.lighter_border};
  }
  ${NoPosts} {
    text-align: center;
  }
  ${NoPosts} p {
    font-size: 16px;
    font-weight: 500;
    padding-top: 48px;
    padding-bottom: 16px;
  }
`;

export default ListingPage;
